import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  gap: (p) => p.spacing(0.5),
};

export const contactIcon: SxStyle = {
  color: (p) => p.palette.success[500],
};

export const companyIcon: SxStyle = {
  color: (p) => p.palette.primary[500],
};
